// src/contexts/HeaderContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface HeaderConfig {
  title: string;              // 頁面標題（必填）
  subtitle?: ReactNode;       // 副標題（如日期、統計數據等）
  leftAction?: ReactNode;     // 左側操作按鈕（如返回按鈕）
  rightActions?: ReactNode[]; // 右側操作按鈕組
  className?: string;         // 自定義樣式
  subHeader?: ReactNode;      // Sub Header 內容（如 Tab 區域）
  containerMaxWidth?: string; // 自定義 main 容器的 max-width（如 'max-w-7xl', 'max-w-screen-2xl', 'max-w-full'）
}

interface HeaderContextType {
  config: HeaderConfig | null;
  setConfig: (config: HeaderConfig | null) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

interface HeaderProviderProps {
  children: ReactNode;
}

export const HeaderProvider: React.FC<HeaderProviderProps> = ({ children }) => {
  const [config, setConfig] = useState<HeaderConfig | null>(null);

  // React 保證 useState 返回的 setter 函數是穩定的，所以不需要 useCallback
  // 只需要確保 context value 對象在 config 變化時才重新創建
  const value = React.useMemo(() => ({
    config,
    setConfig
  }), [config]);

  return (
    <HeaderContext.Provider value={value}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error('useHeaderContext must be used within a HeaderProvider');
  }
  return context;
};